import { UserProfileData } from '@finxone-platform/shared/sys-config-types';

export class GetPersonalProfile {
  static readonly type = '[PersonalProfile] GetPersonalProfile';
}

export class UpdatePersonalProfile {
  static readonly type = '[PersonalProfile] UpdatePersonalProfile';
  constructor(public payload: UserProfileData) {}
}
